export type SplitPanelFace = 'inside-left' | 'inside-right';

/**
 * Determines whether a card face type represents a split inside panel.
 */
export const isSplitPanelFace = (faceType: string | undefined): faceType is SplitPanelFace =>
  faceType === 'inside-left' || faceType === 'inside-right';
